import React from 'react'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { Select } from 'antd';
import './_SueItemUpdate.css';

interface Props {
    driver: any;
    vehicleData: any;
    onDriverParameterChange: (e: any, paramName: string) => void;
    onVehicleParameterChange: (e: any, paramName: string, isNumber?: boolean) => void;
    onIsDriverVehicleOwnerChange: (e: any) => void;
    onIsIsraeliLicenseChange: (newValue: string) => void;
    onDateChange: (field: string, date: Date) => void;
    onChangeGearType: (value: any) => void;
    licenseTypes: any[];
    onChangeLicenseType: (value: any) => void;
}

const VehicleAndDriverDetails = (props: Props) => {

    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי נהג
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <label>
                            <input type="checkbox" value='1' checked={props.driver && props.driver.isDriverVehicleOwner} onChange={(e: any) => props.onIsDriverVehicleOwnerChange(e)} onBlur={(e: any) => { }} />
                            הנהג הוא בעל הרכב
                        </label>
                    </div>
                    <div className="parameter-item"></div>
                    <div className="parameter-item"></div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverFullName} onChange={(e: any) => props.onDriverParameterChange(e, 'driverFullName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                ת.ז.
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverIdentity} onChange={(e: any) => props.onDriverParameterChange(e, 'driverIdentity')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך לידה
                            </div>
                            <div className="value">
                                <CompDatePicker
                                    disabled={props.driver && props.driver.isDriverVehicleOwner ? true : false}
                                    value={props.driver && props.driver.driverBirthDate}
                                    onChange={(date: Date) => props.onDateChange('driverBirthDate', date)} />
                            </div>
                        </div>
                    </div>

                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                טלפון נייד
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverMobileNumber} onChange={(e: any) => props.onDriverParameterChange(e, 'driverMobileNumber')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                טלפון נוסף
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverPhoneNumber} onChange={(e: any) => props.onDriverParameterChange(e, 'driverPhoneNumber')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                קשר/קרבה בין נהג למבוטח
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverOwnerRelation} onChange={(e: any) => props.onDriverParameterChange(e, 'driverOwnerRelation')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>

                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' רשיון נהיגה
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverLicenseNumber} onChange={(e: any) => props.onDriverParameterChange(e, 'driverLicenseNumber')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סוג רשיון
                            </div>
                            <div className="value">
                                {/* <input type="text"  value={props.driver && props.driver.driverLicenseType} onChange={(e: any) => props.onDriverParameterChange(e, 'driverLicenseType')} onBlur={(e: any) => { }} /> */}
                            <Select
                                    style={{ width: '100%' }}
                                    placeholder=""
                                    value={props.driver && props.driver.driverLicenseType >= 0 ? props.driver.driverLicenseType : -1}
                                    onChange={props.onChangeLicenseType}
                                    options={[{ value: -1, label: 'בחר סוג רשיון'},
                                        {value: 0, label: 'A'},
                                        {value: 1, label: 'B'},
                                        {value: 2, label: 'C'},
                                        {value: 3, label: 'D'},
                                        {value: 4, label: 'E'}
                                     ]}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך הוצאת רשיון
                            </div>
                            <div className="value">
                                <CompDatePicker
                                    disabled={props.driver && props.driver.isDriverVehicleOwner ? true : false}
                                    value={props.driver && props.driver.driverLicensIssueDate}
                                    onChange={(date: Date) => props.onDateChange('driverLicensIssueDate', date)} />
                            </div>
                        </div>
                    </div>

                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                רישיון ישראלי
                            </div>
                            <div className="value">
                                <Select
                                    disabled={props.driver && props.driver.isDriverVehicleOwner ? true : false}
                                    style={{ width: '100%' }}
                                    placeholder="רישיון  ישראלי"
                                    value={props.driver && props.driver.isIsraeliLicense ? '1' : '2'}
                                    onChange={props.onIsIsraeliLicenseChange}
                                    options={
                                        [
                                            {
                                                label: 'כן',
                                                value: '1'
                                            },
                                            {
                                                label: 'לא',
                                                value: '2'
                                            }
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.driver && props.driver.isDriverVehicleOwner ? true : false} value={props.driver && props.driver.driverAddress} onChange={(e: any) => props.onDriverParameterChange(e, 'driverAddress')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item"></div>

                </div>
            </section>
            <section className='with-top-border'>
                <div className='section-sue-title'>
                    פרטי רכב
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סוג רכב
                            </div>
                            <div className="value" 
                            // title={props.driver && props.driver.vehicle && props.driver.vehicle.vehicleOwnership}
                            >
                                <Select
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    placeholder=""
                                    value={props.driver && props.driver.vehicle && props.driver.vehicle.vehicleOwnership >= 0 ? props.driver.vehicle.vehicleOwnership.toString() : ''}
                                    onChange={() => { }}
                                    options={
                                        [
                                            {
                                                label: 'פרטי',
                                                value: '0'
                                            },
                                            {
                                                label: 'מסחרי',
                                                value: '1'
                                            }
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מספר רישוי
                            </div>
                            <div className="value">
                                <input type="text" disabled={true} value={props.driver && props.driver.vehicle && props.driver.vehicle.licenseNumber} onChange={(e: any) => props.onVehicleParameterChange(e, 'licenseNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                קוד דגם
                            </div>
                            <div className="value">
                                <input type="text" disabled={true} value={props.driver && props.driver.vehicle && props.driver.vehicle.modelCode} onChange={(e: any) => props.onVehicleParameterChange(e, 'modelCode', false)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שנת ייצור
                            </div>
                            <div className="value">
                                <input type="text" disabled={true} value={props.driver && props.driver.vehicle && props.driver.vehicle.carYear} onChange={(e: any) => props.onVehicleParameterChange(e, 'carYear', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם הדגם
                            </div>
                            <div className="value">
                                <input type="text" 
                                    disabled={true} 
                                    value={props.driver && props.driver.vehicle && props.driver.vehicle.vehicleSubModel && props.driver.vehicle.vehicleSubModel.name } 
                                    onChange={(e: any) => props.onVehicleParameterChange(e, 'name', false)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תיבת הילוכים
                            </div>
                            <div className="value">
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder=""
                                    value={props.driver && props.driver.vehicle && props.driver.vehicle.gearsType}
                                    onChange={props.onChangeGearType}
                                    options={
                                        [
                                            {
                                                label: 'אוטומטית',
                                                value: 0
                                            },
                                            {
                                                label: 'ידנית',
                                                value: 1
                                            }
                                        ]
                                    }
                                    disabled={true}
                                />
                                {/* <input type="text" value={sueData.vehicle && sueData.vehicle.gearsType} onChange={(e:any)=>{}} onBlur={(e:any)=>{}} /> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                רדיו, תוספות
                            </div>
                            <div className="value">
                                <input type="text" value={props.driver && props.driver.vehicle && props.driver.vehicle.vehicleAdditions} onChange={(e: any) => props.onVehicleParameterChange(e, 'vehicleAdditions')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div> */}
                    
                </div>
            </section>
        </div>
    )
}

export default VehicleAndDriverDetails